<script lang="ts" setup>
import { Str } from '@atabix/core'
import { computed } from 'vue'

import type { Inputable } from '../../../../lib/types/Inputable'
import type { Testable } from '../../../../lib/types/Testable'
import { Checkbox } from '../../checkbox'
import { FormControl, FormField, FormItem } from '../../form'
import { Label } from '../../label'

export interface CheckboxInputProperties extends Testable, Inputable {
  type?: 'checkbox'
  label?: string
  value?: boolean
  disabled?: boolean
}
// Props
const properties = withDefaults(defineProps<CheckboxInputProperties>(), {
  id: '',
  type: 'checkbox',
  class: undefined,
  name: undefined,
  label: undefined,
  value: undefined,
  disabled: false,
  required: false,
})

const modelValue = defineModel<boolean>()
// end Props

// const intermediaryModelValue = defineModel<boolean>()

// Emits

// end Emits

// Refs
// end Refs

// Computed

const sanitizedLabel = computed((): string => {
  const label = properties.label ? Str.purify(properties.label) : ''

  return properties.required ? `${label} *` : label
})

// end Computed

// Functions
// end Functions

// Async Api functions
// end Async Api functions

// Lifecycle Hooks / Init
// end Lifecycle Hooks / Init
</script>

<template>
  <FormField v-slot="{ componentField }" :model-value="modelValue" :name="name || ''">
    <FormItem>
      <FormControl>
        <div class="atabix-checkbox">
          <Checkbox v-bind="componentField" :id="id" v-model="modelValue" :disabled="disabled" />
          <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
          <Label :for="id">
            <slot name="label">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="sanitizedLabel"></span>
            </slot>
          </Label>
        </div>
      </FormControl>
    </FormItem>
  </FormField>
</template>

<style lang="scss">
/* stylelint-disable-next-line block-no-empty */
.atabix-checkbox {
  @apply flex;
  @apply items-center;
  @apply space-x-2;
}
</style>
